if (!customElements.get('mdv-shopby-slider')) {
  customElements.define(
    'mdv-shopby-slider',
    class MDVShopbySlider extends HTMLElement {
      connectedCallback() {
        // Initializes immediately rather than waiting for intersection -
        // confirmed live as a real bug: while un-initialized, the slides
        // render in their raw unstyled/stacked state, then Swiper's
        // transforms (plus this component's own applyCurve positioning)
        // snap into place whenever it does init, causing a huge layout
        // shift (measured live at CLS 1.00 - effectively the entire page's
        // shift budget from this one element) and making this the LCP
        // element too since its unstyled initial state paints large.
        // Every other slider in this theme already initializes Swiper
        // immediately for this exact reason - this one just hadn't been
        // brought in line with that.
        if (this.imageSwiper) return;
        this.init();
      }

      init() {
        const that = this;

        this.imageSwiper = new Swiper(this.querySelector('.imageSwiper'), {
          centeredSlides : true,
          loop           : true,
          slidesPerView  : 1.9,
          spaceBetween   : 10,
          initialSlide   : 0,
          speed          : 500,
          allowTouchMove : false,
          breakpoints: {
            600:  { slidesPerView: 2.4, spaceBetween: 12 },
            768:  { slidesPerView: 3,   spaceBetween: 14 },
            1024: { slidesPerView: 5,   spaceBetween: 16 },
          },
          on: {
            init(s)                     { that.applyCurve(s); },
            slideChange(s)              { that.applyCurve(s); },
            slideChangeTransitionEnd(s) { that.applyCurve(s); },
            resize(s)                   { setTimeout(() => that.applyCurve(s), 100); },
          }
        });

        // ✅ KEY FIX: scope to `this.querySelector` not global `.contentSwiper`
        this.contentSwiper = new Swiper(this.querySelector('.contentSwiper'), {
          slidesPerView  : 1,
          loop           : true,
          initialSlide   : 0,
          speed          : 500,
          allowTouchMove : false,
          navigation: {
            nextEl: this.querySelector('.contentSwiper .swiper-button-next'),
            prevEl: this.querySelector('.contentSwiper .swiper-button-prev'),
          },
          on: {
            slideChange(s) {
              that.imageSwiper.slideToLoop(s.realIndex, 500, false);
            }
          }
        });
      }

      applyCurve(swiper) {
        const slides = Array.from(swiper.slides);

        // ✅ Detect real slide count from unique data-swiper-slide-index values
        const realTotal = new Set(
          slides.map(s => s.getAttribute('data-swiper-slide-index')).filter(Boolean)
        ).size || slides.length;

        const activeReal = swiper.realIndex;

        slides.forEach((slide) => {
          const attr = slide.getAttribute('data-swiper-slide-index');
          const slideReal = attr !== null ? parseInt(attr, 10) : Array.from(slides).indexOf(slide);

          let offset = slideReal - activeReal;

          if (offset >  realTotal / 2) offset -= realTotal;
          if (offset < -realTotal / 2) offset += realTotal;

          const abs = Math.abs(offset);
          let ty, scale, opacity, zIndex;

          if (abs === 0) {
            ty = 0;   scale = 1;    opacity = 1;    zIndex = 10;
          } else if (abs === 1) {
            ty = -12; scale = 0.92; opacity = 0.80; zIndex = 9;
          } else if (abs === 2) {
            ty = -28; scale = 0.82; opacity = 0.50; zIndex = 8;
          } else {
            ty = -38; scale = 0.72; opacity = 0.20; zIndex = 7;
          }

          slide.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
          slide.style.transform  = `translateY(${ty}%) scale(${scale})`;
          slide.style.opacity    = String(opacity);
          slide.style.zIndex     = String(zIndex);
        });
      }
    }
  );
}